import React from "react";

import {
  formatFileSize,
  getFileExt,
} from "../../../../../../components/FileRepo/utils/utils";
import {
  fileIcons,
  DeleteIcon,
} from "../../../../../../components/FileRepo/Icons";
import Tooltip from "@mui/material/Tooltip";

const SelectedFileCard = ({ key, file, removeFile, indexToRemove }) => {
  const filename = file?.name || file?.file_name || "Unknown file";
  const extFromName = getFileExt(filename);
  const extFromType = file?.file_type ? file.file_type.split("/").pop() : "";
  const ext = extFromType || extFromName;
  const FileIcon = fileIcons?.[ext];
  const fileSize = file?.size || file?.file_size || file?.fileSize;
  const fileLabel = fileSize
    ? formatFileSize(fileSize)
    : file?.file_type || "-";

  return (
    <div
      key={key}
      className="bg-[#F7F7F7] p-2 rounded-[5px] flex items-center justify-between"
    >
      <Tooltip title={filename}>
        <div className="flex items-center gap-2 max-w-[70%]">
          {FileIcon && <FileIcon />}
          <span className="truncate text-[#000000] font-normal text-[0.8rem] max-w-[80%]">
            {filename}
          </span>
        </div>
      </Tooltip>
      <div className="flex items-center gap-3">
        <span className="text-[#555555] font-normal text-[0.8rem]">
          {fileLabel}
        </span>
        <button
          onClick={() => {
            removeFile(indexToRemove);
          }}
          className="p-0 m-0 bg-transparent border-0 leading-none text-inherit w-fit h-fit cursor-pointer"
        >
          <DeleteIcon />
        </button>
      </div>
    </div>
  );
};

export default SelectedFileCard;
